module.exports = __webpack_public_path__ + "static/img/title.4bd954d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/bruderertrans/title.jpg
// module id = 360
// module chunks = 1